import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async getSubjob(id) {
            var meta = { clientApiMethod: 'getSubjob', input: { id: id } }
            var response = await client().get(store.state.apiRouteRoot + "MachineJob/get/" + id, { meta: meta })
            return response?.data;
        },
        async bulkAddMachineJobs(dto) {
            var meta = {
                clientApiMethod: 'BulkAddMachineJobs',
                input: { dto },
                //successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.machine.machine") })
            }
            var response = await client().post(`${store.state.apiRouteRoot}MachineJob/BulkAdd`, dto, { meta: meta, timeout: 120000 })
            return response;
        },
        async createSubjob(newsubjob) {
            var meta = {
                clientApiMethod: 'createSubjob',
                input: { newsubjob },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.job.machine_job") })
            }
            var response = await client().put(store.state.apiRouteRoot + "MachineJob/add/parent/" + newsubjob.ParentId, newsubjob, { meta: meta })
            return response?.data;
        },
        async transferSubjobDetails(subjobId, newMachineId) {
            var meta = {
                clientApiMethod: 'transferSubjobDetails',
                input: { subjobId: subjobId, newMachineId: newMachineId },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.job.machine_job") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "MachineJob/Transfer/" + subjobId + "/ToMachine/" + newMachineId, null, { meta: meta })
            return response?.data;
        },
        async changeSubjob(subjob) {
            var meta = {
                clientApiMethod: 'changeSubjob',
                input: { subjob },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.job.machine_job") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "MachineJob/change/" + subjob.Id, subjob, { meta: meta })
            return response?.data;
        },
        async changeSubjobFlag(jobId, value) {
            var meta = {
                clientApiMethod: 'changeSubjobFlag',
                input: { jobId: jobId, value: value },
                //successText: 'Successfully changed flag.'
            }
            var query = `?value=${value !== null ? value : ''}`;
            var response = await client().patch(`${store.state.apiRouteRoot}MachineJob/change/${jobId}/flag${query}`, null, { meta: meta })
            return response?.data;
        },
        async removeSubjob(subjobId) {
            var meta = {
                clientApiMethod: 'removeSubjob',
                input: { subjobId: subjobId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.job.machine_job") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "MachineJob/remove/" + subjobId, { meta: meta })
            return response?.data;
        },
        async getSubjobs(parentId) {
            var meta = { clientApiMethod: 'getSubjobs', input: { parentId: parentId } }
            var response = await client().get(store.state.apiRouteRoot + 'job/' + parentId + "/subjobs", { meta: meta })
            return response?.data;
        },
    }
}